import formatMoney from './formatMoney';

export default function calculateTotal(orders, products) {
  const total = orders.reduce((prevVal, curVal) => {
    const product = products.find(
      (singleProduct) => singleProduct.id === curVal.id
    );
    return prevVal + product.price;
  }, 0);
  return formatMoney(total);
}
